module.exports = __webpack_public_path__ + "static/media/arrow-to-left.4064c796.svg";